var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-widget"},[_c('div',{staticClass:"cd-donut",style:(_vm.donutStyle)},[_c('span',{staticClass:"cd-value"},[_vm._v(_vm._s(_vm.value)+"%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }